import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=5343d3bd&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5343d3bd')) {
      api.createRecord('5343d3bd', component.options)
    } else {
      api.reload('5343d3bd', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=5343d3bd&", function () {
      api.rerender('5343d3bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-27x0aHFxeeg0L/JS/comp/ImgFallback.vue"
export default component.exports